export default "__VITE_ASSET__B2pjuy2k__"